import Logger from '../lib/logger';
import { getCardData, handlize } from '../lib/util.functions';

class ProductModal extends HTMLElement {
  #NAME = 'ProductModal'
  #launchBtns
  #modal
  #multiModal
  #productCard
  #header

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    //
    this.#modal = this.querySelector('bundler-modal');
    this.#multiModal = document.querySelector('multi-modal');
    this.#launchBtns = Array.from(document.querySelectorAll('[data-launch-modal]'));
    this.#header = document.querySelector('.bundler-header');
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    //
    this.#launchBtns.forEach(el => {
      el.addEventListener('click', (e) => this.#openModal(e));
    });
    //
    this.#modal.addEventListener('modalevent', (e) => this.#onModalEvent(e));
  }

  #openModal = (e) => {
    e.preventDefault();
    Logger.info(`${this.#NAME} > openModal > ${e.target.dataset.productId}`);
    //
    const productId = e.target.dataset.productId;
    const groupIndex = e.target.dataset.groupIndex;
    const curStep = this.#header.dataset.step;
    this.#productCard = document.querySelector(`bundler-step[data-bundler-step="${curStep}"] product-card[data-product-id="${productId}"][data-group-index="${groupIndex}"]`);
    //
    if (e.target.querySelector('input:checked') && e.target.dataset.selectMultiple === 'false') {
      this.#dispatchBundleStepEvent(getCardData(this.#productCard, 'remove', { quantity: 0 }));
      return;
    }
    //
    if  (e.target.dataset.hasConnected === 'true' && this.#productCard.productBtnInput.checked) {
      this.#onModalEvent({ detail: { name: 'remove' }});
    } else {
      if (this.#productCard.dataset.hasConnected == 'true') {
        if (this.#productCard.productBtnInput.checked) {
          this.#productCard.templateForm?.setAttribute('disabled', true);
          this.#productCard.templateBtnInput?.setAttribute('checked', true);
        } else {
          this.#productCard.templateForm?.removeAttribute('disabled');
          this.#productCard.templateBtnInput?.removeAttribute('checked');
        }
      }
      this.#modal.dataset.groupIndex = groupIndex;
      this.#modal.dataset.productId = productId;
      this.#modal.dataset.quantity = this.#productCard.dataset.quantity;
      this.#modal.dataset.show = 'true';
    }
    
  }

  #onModalEvent(e) {
    Logger.info(`${this.#NAME} > onModalEvent`, e.detail);
    //
    switch (e.detail.name) {
      case 'add':
        this.#modal.dataset.show = 'false';
        this.#productCard.otherRadios();
        this.#dispatchBundleStepEvent(getCardData(this.#productCard, e.detail.name, { quantity: 1 }));
        //
        if (this.#productCard.connectedProductCard) {
          setTimeout(() => {
            this.#productCard.connectedProductCard.productBtn.click();
          }, 400);
        }
        break;

      case 'remove':
        this.#modal.dataset.show = 'false';
        const cardData = getCardData(this.#productCard, e.detail.name, { quantity: 0 });
        if (this.#productCard.dataset.selectMultiple === 'true') {
          this.#productCard.querySelectorAll(`variant-updater`).forEach(vu => {
            this.#dispatchBundleStepEvent({...cardData, data: {...cardData.data, variantId: vu.dataset.variantId}});
          })
        } else {
          this.#dispatchBundleStepEvent(cardData);
        }
        
        break;

      case 'update':
        if (e.detail.quantity === '0') {
          this.#modal.dataset.show = 'false';
          this.#dispatchBundleStepEvent(getCardData(this.#productCard, 'remove', { quantity: 0 }));
        } else {
          this.#dispatchBundleStepEvent(getCardData(this.#productCard, e.detail.name, { quantity:  parseInt(e.detail.quantity) }));
        }
        //
        /* if (this.#productCard.connectedProductCard) {
          setTimeout(() => {
            this.#productCard.connectedProductCard.productBtn.click();
          }, 400);
        } */
        break;

      case 'form data':
        const multiple = e.detail.multiple;
        let options = e.detail['option-names'];
        if (options === '') options = undefined;
        //
        let customText;
        if (e.detail.numLines) {
          const numCustomLines = parseInt(e.detail.numLines);
          customText = '';
          for (let i = 1; i <= numCustomLines; i++) {
            const textValue = e.detail[`custom_text_${i}`]
            if (textValue !== '') customText = `${customText}${i === 1 ? '' : '|' }${textValue}`;
          }
        }
        //
        this.#modal.dataset.show = 'false';
        //
        this.#productCard.otherRadios();
        if (!multiple && this.#productCard.productBtnInput.checked) {
          this.#dispatchBundleStepEvent(getCardData(this.#productCard, 'remove', { quantity: 0 }));
        }
        //
        if (multiple) {
          this.#addMultiple(e, options, customText);
        } else {
          options?.split(',').forEach((name, i, arr) => {
            if (i === 0) options = options.concat('|');
            options = options.concat(e.detail[name]);
            if (i < arr.length - 1) options = options.concat(',');
          });
          const price = this.#productCard.dataset.included !== 'true' && e.detail.price !== this.#productCard.dataset.productPrice ? e.detail.price : this.#productCard.dataset.productPrice;
          //
          this.#dispatchBundleStepEvent(getCardData(this.#productCard, 'add', { 
            quantity: e.detail.quantity ? parseInt(e.detail.quantity) : 1, 
            variantId: e.detail.variantId,
            image: !!e.detail.image && e.detail.image !== this.#productCard.dataset.productImage ? e.detail.image : this.#productCard.dataset.productImage,
            price,
            options,
            multiple,
            customText,
            discount: e.detail['use-after-first-discount'] ? [price, e.detail['use-after-first-discount'] ] : null,
          }, this.#productCard.productBtnInput.type === 'radio'));
        }
        break
    
      default:
        break;
    }
  }

  #addMultiple(e, optionNames, customText) {
    let variantId, variantKey, price, image, options, quantity, discount;
    //
    for (const [key, value] of Object.entries(e.detail)) {
      if (key.startsWith('multiple-') && this.#modal.querySelector(`label:has(input:checked) + multiple-updater:has(input[name="${key}"])`)) {
        if (optionNames && optionNames !== '') {
          options = optionNames;
          options.split(',').forEach((name, i, arr) => {
            if (i === 0) options = options.concat('|');
            //
            if (i < arr.length - 1) {
              options = options.concat(e.detail[name]);
              options = options.concat(',');
            } else {
              options = options.concat(key.split('multiple-')[1]);
            }
          });
        }
        //
        variantKey = handlize(options.split('|')[1]);
        variantId = e.detail[variantKey];
        price = e.detail[`${variantKey}-price`];
        image = e.detail[`${variantKey}-image`] || this.#productCard.dataset.productImage;
        discount = e.detail[`${variantKey}-after-price-discount`] ? [price, e.detail[`${variantKey}-after-price-discount`]] : null;
        quantity = parseInt(value);
        console.log(getCardData(this.#productCard, 'add'));
        if (quantity) {
          this.#dispatchBundleStepEvent(getCardData(this.#productCard, 'add', { 
            quantity: parseInt(value), 
            productId: e.detail.productId,
            title: e.detail.productTitle,
            variantId,
            image,
            price,
            options,
            multiple: true,
            customText,
            discount,
            onlyForProductId: this.#productCard.dataset.hasConnected === 'true' ? this.#productCard.nextElementSibling.firstElementChild.dataset.onlyForProductId : undefined
          }), this.#productCard.productBtnInput.type === 'radio');
        }
      }
    }
    //
    if (!e.detail.connected) {
      setTimeout(() => {
        if (this.#productCard.dataset.numAllowed !== this.#productCard.dataset.quantity) {
          this.#multiModal.openModal();
        }
      }, 100);
    }
  }

  #dispatchBundleStepEvent(detail, replace = false) {
    Logger.info(`${this.#NAME} >  #dispatchBundleStepEvent`, detail, replace);
    const event = new CustomEvent('bundlestep:event', {
      detail: {...detail, replace},
      bubbles: true
    });
    this.#productCard.dispatchEvent(event);
  }
  
}

customElements.define('product-modal', ProductModal);